import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { BankingInformationService } from './banking-information.service';
import { Observable } from 'rxjs';
import { CardComponent } from '@ui/global-shared/components/card/card.component';
import { AsyncPipe } from '@angular/common';
import { InfoTextComponent } from '@ui/global-shared/components/info-text/info-text.component';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';

@Component({
  selector: 'pt-banking-information-confirm',
  templateUrl: './banking-information-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CardComponent,
    InfoTextComponent,
    Bind,
    Button,
    RouterLink,
    AsyncPipe,
  ],
})
export class BankingInformationConfirmComponent implements OnInit {
  private activeRoute = inject(ActivatedRoute);
  private bankingInfoService = inject(BankingInformationService);

  success$: Observable<boolean>;

  ngOnInit(): void {
    this.success$ = this.activeRoute.params.pipe(
      map((params) => params['token']),
      switchMap((token) => this.bankingInfoService.verifyToken(token)),
      shareReplay(1),
    );
  }
}
